var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode2Black24Dp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qr_code_2_black_24dp_svg__qr_code_2_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "2 2 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_code_2_black_24dp_svg__Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "qr_code_2_black_24dp_svg__Rectangle_382",
    "data-name": "Rectangle 382"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr_code_2_black_24dp_svg__Path_876",
    "data-name": "Path 876",
    d: "M19,27H16.333V24.333H19Zm-2.667-9.333H13.667v6.667h2.667ZM27,15H24.333v5.333H27Zm-2.667-2.667H21.667V15h2.667ZM8.333,15H5.667v2.667H8.333ZM5.667,12.333H3V15H5.667ZM15,5.667h2.667V3H15ZM5,5V9H9V5Zm6,6H3V3h8ZM5,21v4H9V21Zm6,6H3V19h8ZM21,5V9h4V5Zm6,6H19V3h8ZM24.333,24.333v-4H19V23h2.667v4H27V24.333ZM21.667,15H16.333v2.667h5.333Zm-5.333-2.667h-8V15H11v2.667h2.667V15h2.667ZM17.667,11V8.333H15V5.667H12.333V11ZM8,6H6V8H8ZM8,22H6v2H8ZM24,6H22V8h2Z",
    transform: "translate(1 1)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode2Black24Dp);
export default __webpack_public_path__ + "static/media/qr_code_2_black_24dp.c63f1916181880fe2fdf5094cc28dba8.svg";
export { ForwardRef as ReactComponent };